export interface BookPartLinkI {
    value: string;
    confidence: number;
    referenceTo: string;
    articleTo: string;
    publicationId: number;
    publicationType: PublicationTypeE;
}

export enum PublicationTypeE {
    DOCUMENT = 'DOCUMENT',
    BOOK = 'BOOK',
    BOOKPART = 'BOOKPART',
    USER_FILE = 'USER_FILE'
}
